/**
 * Keep payoff copy in the client as presentation. Explain benefits rather than repeating row titles; omit
 * durations so users evaluate the benefit before the time cost.
 */
import type { SetupStep, SetupStepId } from "~vue/ProfileSetup/types";

export type Translate = (key: string) => string;

export interface SetupAskCopy {
    payoff: string;
}

export function setupAskCopy(t: Translate): Record<SetupStepId, SetupAskCopy> {
    return {
        identity: { payoff: t("onboarding.profileSetup.asks.identity.payoff") },
        calendar: { payoff: t("onboarding.profileSetup.asks.calendar.payoff") },
        perspective: { payoff: t("onboarding.profileSetup.asks.perspective.payoff") },
        publish: { payoff: t("onboarding.profileSetup.asks.publish.payoff") },
    };
}

/**
 * Use Start/Resume consistently on setup and homepage entry buttons; repeating the next ask's verb makes
 * the entry button look like a duplicate row action.
 */
export function setupCtaLabel(t: Translate, steps: SetupStep[], completedCount: number): string {
    if (steps.every((step) => step.done)) {
        return "";
    }
    return completedCount === 0 ? t("onboarding.profileSetup.asks.start") : t("onboarding.profileSetup.asks.resume");
}
